var cov_y3xhva591 = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Transfer/index.ts",
      hash = "8a03b3f5f35e2d146d8c6799378964dcfa74e25e",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Transfer/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 7,
          column: 38
        },
        end: {
          line: 7,
          column: 96
        }
      },
      "1": {
        start: {
          line: 8,
          column: 23
        },
        end: {
          line: 11,
          column: 11
        }
      },
      "2": {
        start: {
          line: 13,
          column: 0
        },
        end: {
          line: 13,
          column: 47
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import Transfer from './Transfer';
import inputable from '../Form/inputable';
import { compose } from '../utils/func';
import Datum from '../Datum';
var bindProps = (cov_y3xhva591.s[0]++, ['disabled', 'limit', 'format', 'prediction', 'separator']);
var exportTransfer = (cov_y3xhva591.s[1]++, compose(inputable, Datum.hoc({
  bindProps: bindProps
}))(Transfer));
cov_y3xhva591.s[2]++;
exportTransfer.displayName = 'ShineoutTransfer';
export default exportTransfer;